import React, { useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import ICONS, { ICON_COLORS } from "../config/icon";
import { MonoButton, PaperDarkBG } from "../kits";
import { FaYoutube, FaVimeo, FaCloudSunRain } from "react-icons/fa";
import RoughBorder from "../kits/LayoutKit/RoughBorder";

function CourseCard({ course }) {
  const cardRef = useRef();

  // Kurs-URL
  const coursePath = course?.slug
    ? `/course/${course.slug}`
    : `/course/${course?.id ?? ""}`;

  const Icon = ICONS[course?.icon] ?? ICONS.default;
  const colorClass = ICON_COLORS[course?.icon] ?? ICON_COLORS.default;

  // Plattform-Badge
  const platformIcons = {
    YouTube: FaYoutube,
    Vimeo: FaVimeo,
    Cloud: FaCloudSunRain,
  };
  const PlatformIcon = platformIcons[course?.platform] ?? null;
  const platformLabel = course?.platform ?? "";

  // Beschreibung normalisieren
  const descriptionItems = useMemo(() => {
    if (!course?.description) return [];

    if (Array.isArray(course.description)) return course.description;

    if (typeof course.description === "string") {
      let str = course.description.trim();

      try {
        const parsed = JSON.parse(str);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        const unescaped = str.replace(/\\"/g, '"');
        try {
          const parsed = JSON.parse(unescaped);
          if (Array.isArray(parsed)) return parsed;
        } catch (e2) {}
      }

      if (str.startsWith("[") && str.endsWith("]")) {
        str = str.slice(1, -1);
      }

      return str
        .split(/\s*,\s*/)
        .map((s) =>
          s.replace(/^"|"$/g, "").replace(/^'|'$/g, "").trim()
        )
        .filter(Boolean);
    }

    return [String(course.description)];
  }, [course?.description]);

  return (
    <div ref={cardRef} className="relative">
      {/* Plattform-Badge */}
      {PlatformIcon && (
        <div className="absolute -top-3 -left-3 flex flex-col items-center z-10">
          <div className="border-black p-2 rounded-full hover:shadow-md -rotate-12">
            <PlatformIcon className="text-[#151515] w-6 h-6" />
          </div>
          <span className="text-[10px] text-[#151515] mt-1 bg-gray-50 px-1 py-0.5 rounded shadow-sm border border-gray-300">
            {platformLabel}
          </span>
        </div>
      )}

      {/* Karten-Inhalt */}
      <div className="bg-[#f0ede1] 
      rounded-xl p-6 flex flex-col 
      h-full min-h-[350px] 
      font-mono 
      shadow-md">
        {course ? (
          <>
         
           {/* Header (Terminal Style) */}
              <div className="
            mb-4
  rounded-lg
  p-4
  bg-[#171717]
  border border-brand
  font-mono
          
          shadow-inner
          shadow-[#373737]
 
              
              ">
            
   
   
    {/* Title row */}
  <div className="mt-1 flex items-start gap-3 ">
    <Icon className={`w-6 h-6 shrink-0 mt-0.5 ${colorClass}`} />
    <h3 className="text-[15px] sm:text-[16px] font-semibold text-[#d0cbb8] leading-snug">
      {course.title}
    </h3>
  </div>

  
  
  
  
  {/* Terminal line */}



  <div className="
  flex items-center 
  mt-4
  justify-between 
  gap-3 
  text-[11px] text-[#d0cbb8]/55">
    <span className="truncate">
      <span className="text-brand">&gt;</span>{" "}
      <span className="text-brand">course/</span>
      <span className="text-[#d0cbb8]">
        {course?.slug || course?.id || "preview"}
      </span>
    </span>

    {/* optional tiny label (desktop loves this) */}
    <span className="hidden 
    md:inline-block text-[9px] px-2 py-0.5 
    rounded border border-brand text-brand">
      {course?.platform || "praxistraining"}
    </span>
  </div>


    {/* Scope row */}
    <div className="mt-2">
  <div className="text-[11px] items-start flex text-[#d0cbb8]/55">
   <span className="truncate">
  <span className="text-brand">&gt;</span>{" "}
    <span className="text-brand">scope:</span>{" "}
    <span className="text-[#d0cbb8]/70">
      {(course?.scope?.length ? course.scope : ["web", "systems", "content"]).join(" · ")}
    </span>
    </span>
  </div>
</div>



</div>


            {/* Fakten (NEU) */}
            <div className="text-[#151515] border border-brand rounded-md py-2 px-4 mb-4 font-mono leading-tight text-xs tabular-nums">
              <PaperDarkBG>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  {/* Title Chip */}
                  <span className="inline-flex items-center gap-2 bg-[#151515] rounded-sm px-2 py-1 -ml-2 text-xs text-[#d0cbb8]">
                    Praxisprojekt · Mentoring
                  </span>

                  {/* optional: Instructor nur wenn du willst */}
                  {course?.instructor && (
                    <span className="inline-flex items-center gap-2 bg-[#151515] rounded-sm px-2 py-1 -mr-2 text-xs text-[#d0cbb8]/80">
                      {course.instructor}
                    </span>
                  )}
                </div>
              </PaperDarkBG>

              {/* meta chips statt katalog-liste */}
              <div className="mt-3 flex flex-wrap gap-2">
                <span className="inline-flex items-center rounded-md border border-brand/40 bg-[#f0ede1] px-2 py-1">
                  Individuell
                </span>

                <span className="inline-flex items-center rounded-md border border-brand/40 bg-[#f0ede1] px-2 py-1">
                  Remote / vor Ort
                </span>

                {course?.durationDays && course.durationDays !== "0" && (
                  <span className="inline-flex items-center rounded-md border border-brand/40 bg-[#f0ede1] px-2 py-1">
                    {course.durationDays} Tage
                  </span>
                )}
              </div>

              {/* Preise: kleine Chips wie die anderen */}
              {(course?.priceOnline || course?.price) && (
                <div className="mt-3 flex flex-wrap gap-2 text-[11px] text-[#151515]/70 text-left w-full">
                  {course?.priceOnline && course.priceOnline !== "0" && (
                    <span className="inline-flex items-center rounded-md border border-brand/40 bg-[#f0ede1] px-2 py-1">
                      Remote ab {course.priceOnline} €
                    </span>
                  )}

                  {course?.price && course.price !== "0" && (
                    <span className="inline-flex items-center rounded-md border border-brand/40 bg-[#f0ede1] px-2 py-1">
                      Vor Ort ab {course.price} €
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* Beschreibung */}
            <ul className="pl-4 text-xs text-left text-slate-800 space-y-1 mb-4 list-[square]">
              {descriptionItems.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>

            {/* CTA */}
            <div className="mt-auto">
              <Link to={coursePath}>
                <MonoButton
                  className="w-full mt-4 text-sm"
                  textColor="text-[#d0cbb8]"
                  underlineColors="ZenAmber"
                >
                  Diesen Kurs ansehen
                </MonoButton>
              </Link>
            </div>
          </>
        ) : (
          <p className="text-red-500">
            Kursinformationen sind derzeit leider nicht verfügbar.
          </p>
        )}
      </div>

      {/* RoughBorder GANZ AUSSEN */}
      <RoughBorder
        parentRef={cardRef}
        radius={10}
        padding={3}
        color="#AC8E66"
        strokeWidth={0.3}
        roughness={1}
        bowing={2}
      />
    </div>
  );
}

export default CourseCard;
